import { Badge, BadgeContent } from './styled'

export const PlanBadge = ({ backgroundColor, color, text }) => {
  return (
    <Badge backgroundColor={backgroundColor}>
      <BadgeContent color={color}>{text}</BadgeContent>
    </Badge>
  )
}
